// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"FullPageLoader_loaderContainer__3ZbpE","loader":"FullPageLoader_loader__Iog19"};